export const CLEIC_APP_CHANNEL_QUERY_KEY = 'cleic_app_channel';

const APP_URLS_BY_CHANNEL = Object.freeze({
  ledger: Object.freeze({
    live: 'https://ledger.cleic.com',
    preview: 'https://preview-ledger.cleic.com',
    lab: 'https://lab-ledger.cleic.com',
  }),
  lens: Object.freeze({
    live: 'https://lens.cleic.com',
    preview: 'https://preview-lens.cleic.com',
    lab: 'https://lab-lens.cleic.com',
  }),
});

const CHANNEL_TITLE_PREFIX = Object.freeze({
  preview: 'Preview',
  lab: 'Lab',
});

function normalizeCleicAppChannel(value) {
  const normalized = String(value ?? '').trim().toLowerCase();
  if (normalized === 'live' || normalized === 'prod' || normalized === 'production') return 'live';
  if (normalized === 'preview' || normalized === 'pr') return 'preview';
  if (normalized === 'lab' || normalized === 'staging' || normalized === 'stage') return 'lab';
  return null;
}

function inferCleicAppChannelFromHost(hostname) {
  const host = String(hostname ?? '').trim().toLowerCase();
  if (host === 'lab-ledger.cleic.com' || host === 'lab-lens.cleic.com') return 'lab';
  if (host === 'preview-ledger.cleic.com' || host === 'preview-lens.cleic.com') return 'preview';
  if (host === 'ledger.cleic.com' || host === 'lens.cleic.com') return 'live';
  return null;
}

export function resolveCleicAppChannel() {
  if (typeof window === 'undefined') return null;
  const explicit = normalizeCleicAppChannel(
    new URLSearchParams(window.location.search).get(CLEIC_APP_CHANNEL_QUERY_KEY),
  );
  return explicit ?? inferCleicAppChannelFromHost(window.location.hostname);
}

export function buildCleicDocumentTitle(appName, channel = resolveCleicAppChannel()) {
  const prefix = channel ? CHANNEL_TITLE_PREFIX[channel] : null;
  return prefix ? `${prefix} · ${appName}` : appName;
}

export function applyCleicDocumentTitle(appName) {
  const title = buildCleicDocumentTitle(appName);
  if (typeof document !== 'undefined') {
    document.title = title;
  }
  return title;
}

export function resolveCleicAppUrl(app, configuredUrl = '') {
  const channel = resolveCleicAppChannel();
  const channelUrl = channel ? APP_URLS_BY_CHANNEL[app]?.[channel] : null;
  return channelUrl || String(configuredUrl || APP_URLS_BY_CHANNEL[app]?.live || '').trim();
}

export function appendCleicAppChannel(targetUrl, channel = resolveCleicAppChannel()) {
  const trimmed = String(targetUrl ?? '').trim();
  if (!trimmed || !channel) return trimmed;
  try {
    const url = new URL(trimmed);
    url.searchParams.set(CLEIC_APP_CHANNEL_QUERY_KEY, channel);
    return url.toString();
  } catch {
    return trimmed;
  }
}
